module.exports = __webpack_public_path__ + "static/media/unininini_doru.34528a31.jpg";